// Path: src\Components\Rewards\RewardStore\RewardStoreList.jsx
import React, { useCallback, useEffect, useRef, useState } from "react";
import BaseHome from "../../Home/BaseHome";
import Myntra from "../../../assets/images/myntra.png";
import Diamond from "../../../images/Diamond.png";
import { rewardCategoryList } from "../../../api/rewardCategory.api";
import { rewardProductList } from "../../../api/rewardProduct.api";
import { url } from "../../../config/url";
import ListLoader from "../../Common/ListLoader";
import { t } from "i18next";
export const initialFilter = {
  pagination: {
    pageNo: 1,
    recordPerPage: 100,
    sortBy: "order",
    sortDirection: "desc",
  },
};

const RewardStore = ({
  isReedemPopup,
  setIsReedemPopup,
  reedemItem,
  setReedemItem,
  isReward,
  setIsReward,
}) => {
  // State to track the active tab
  const [activeTab, setActiveTab] = useState(0);
  const [filter, setFilter] = useState(initialFilter);
  const [categoryList, setCategoryList] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const [productList, setProductList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordPerPage, setRecordPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [changeCategory, setChangeCategory] = useState(false);

  useEffect(() => {
    fetchRewardCategory();
  }, []);

  useEffect(() => {
    if (currentPage <= totalPages) loadMore();
  }, [currentPage]);

  useEffect(() => {
    if (categoryId) {
      fetchRewardProduct();
    } else if (!categoryId && changeCategory === true) {
      fetchRewardProduct();
    }
  }, [categoryId]);

  const loadMore = async () => {
    if (!changeCategory) {
      fetchRewardProduct();
    }
  };

  const observer = useRef();
  const lastPostElementRef = useCallback(
    async (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          setCurrentPage((prevPage) => prevPage + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading]
  );

  const fetchRewardCategory = async () => {
    try {
      const res = await rewardCategoryList(filter);

      if (res?.success && res?.data) {
        let list = [
          {
            index: 0,
            _id: "",
            name: "All",
            img: null,
          },
        ];
        if (res?.data && res?.data?.length > 0) {
          for (let i = 0; i < res?.data?.length; i++) {
            let obj = { ...res?.data?.[i] };
            obj.index = i + 1;
            list.push(obj);
          }
        }
        setCategoryList(list);
      } else {
        setCategoryList([]);
      }
    } catch (error) {}
  };

  const fetchRewardProduct = async () => {
    setLoading(true);
    console.log(loading);
    try {
      let data = {
        pagination: {
          pageNo: currentPage,
          recordPerPage: recordPerPage,
          sortBy: "order",
          sortDirection: "desc",
        },
      };

      if (categoryId) {
        data.search = {
          rewardCategory: categoryId,
        };
      }

      const res = await rewardProductList(data);
      setLoading(false);
      setChangeCategory(false);
      if (res?.success && res?.data) {
        let list = [];
        if (res?.data && res?.data?.length > 0) {
          for (let i = 0; i < res?.data?.length; i++) {
            let obj = { ...res?.data?.[i] };
            obj.index = i + 1;
            list.push(obj);
          }
        }

        if (currentPage == 1) {
          setProductList(list);
        } else {
          setProductList([...productList, ...list]);
        }
        setTotalPages(res?.totalPages);
      } else {
        setProductList([]);
      }
    } catch (error) {
      setLoading(false);
      console.log(loading);
    }
  };

  // Function to change the active tab
  const handleTabClick = (tab) => {
    setChangeCategory(true);
    setCategoryId(tab?._id);
    setActiveTab(tab?.index || 0);
    setCurrentPage(1);
  };

  const verifyAccount = (reward) => {
    setIsReedemPopup(true);
    setIsReward(true);
    setReedemItem(reward);
  };

  return (
    <div className="rewardsstore-main-wrap">
      <div className="row reward-store-inner-tabs">
        <div className="reward-store-tabs-child">
          {categoryList &&
            categoryList?.length > 0 &&
            categoryList.map((tab) => (
              <div
                key={tab?.index || 0}
                className={`reward-store-tabs-text ${
                  activeTab === tab?.index || 0 ? "active-tab" : ""
                }`}
                style={{
                  color: activeTab === tab?.index || 0 ? "red" : "white",
                }}
                onClick={() => handleTabClick(tab)}
              >
                {/* <span>
                  {tab?.name?.length > 6 ? (
                    <marquee>{tab?.name.toLowerCase()}</marquee>
                  ) : (
                    tab?.name.toLowerCase()
                  )}
                </span> */}
                <span>{tab?.name?.toLowerCase()}</span>
              </div>
            ))}
        </div>
      </div>

      <div
        className={`reward-store-card-wrap ${
          productList?.length > 0 ? "w-94" : "w-100"
        }`}
      >
        {productList?.length > 0
          ? productList.map((reward, index) => (
              <div
                key={index}
                ref={
                  productList?.length === index + 1 ? lastPostElementRef : null
                }
                className="reward-store-card-inner-wrap"
              >
                <div className="reward-card">
                  <div className="reward-icon">
                    <img
                      src={url?.IMAGE_URL + reward?.img?.default}
                      alt={reward?.name}
                    />
                  </div>
                  <div className="reward-details">
                    <p className="reward-title ">
                    {reward?.name?.length > 14 ? (
                        <marquee>  {reward?.name}</marquee>
                      ) : (
                        reward?.name
                      )}
                      {/* {reward?.name} */}
                      </p>
                    <p className="reward-price">
                    <span className="ms-1">
                        {reward?.voucherInfo?.currency?.code === "INR" ? (
                          reward?.voucherInfo?.currency?.symbol
                        ) : (
                          <img
                            className="rewardstore-img-icon-size"
                            src={
                              url?.IMAGE_URL +
                              reward?.voucherInfo?.currency?.img?.default
                            }
                            alt={reward?.name}
                          />
                        )}
                      </span>
                    {" " + reward?.voucherInfo?.amount}
                    
                      
                    </p>
                  </div>
                  <div className="reward-redeem">
                    <button
                      className="redeem-button"
                      onClick={() => verifyAccount(reward)}
                    >
                      {/* {t("rewards-store.redeem_for")}{" "} */}
                     <div>
                     <span className="redeem-points f-18">
                        {reward?.redeemInfo?.amount}
                      </span>{" "}
                      <span>
                        {reward?.redeemInfo?.currency?.code === "INR" ? (
                          reward?.redeemInfo?.currency?.symbol
                        ) : (
                          <img
                            className="rewardstore-img-icon-size mb-1"
                            src={
                              url?.IMAGE_URL +
                              reward?.redeemInfo?.currency?.img?.default
                            }
                            alt={reward?.name}
                          />
                        )}
                      </span>
                     </div>
                    </button>
                  </div>
                </div>
              </div>
            ))
          : !loading && (
              <>
                <div className="no-record-found-center-rewards">
                  <span className="text-center">no data found</span>
                </div>
              </>
            )}

        {loading && (
          <div className="w-100 d-flex justify-content-center">
            {" "}
            <ListLoader />
          </div>
        )}
      </div>
    </div>
  );
};

export default RewardStore;
